module.exports = __webpack_public_path__ + "img/test_r13.3c36adc0.png";